module.exports = __webpack_public_path__ + "static/media/dgs1.png.94634883.jpg";